import { getAllState } from '@/api/state.api';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useStateStore } from '@/store/state.store';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';

export const StateServiceApi = () => {
	const setStateData = useStateStore(state => state.setStateData);
	const isAuthenticated = useIsAuthenticated();
	const { data, isLoading } = useQuery({
		queryKey: ['state'],
		queryFn: () => getAllState(),
		enabled: isAuthenticated,
		retry: isAuthenticated,
		refetchOnWindowFocus: true,
		staleTime: 1000 * 60,
		placeholderData: keepPreviousData,
	});

	useEffect(() => {
		if (!isAuthenticated || isLoading || !data) return;
		setStateData(data);
	}, [data, isAuthenticated, isLoading, setStateData]);

	return <></>;
};
